/**
 * Tracer Bullet: Minimal test page for useStream + @launch10/langgraph-server
 *
 * Proves the full stack: useStream -> createLangGraphApi -> BullMQ -> worker -> brainstorm graph
 * Dev-only — accessed at /brainstorm-stream-test
 */
import { useBrainstormStream } from "@components/brainstorm/hooks/useBrainstormStream";
import { useEffect } from "react";

export default function BrainstormStreamTest() {
  const thread = useBrainstormStream();

  // Log every message update with detailed property access
  useEffect(() => {
    if (!thread.messages?.length) return;
    console.log("=== [StreamTest] messages updated ===");
    thread.messages.forEach((m: any, i: number) => {
      console.log(`[StreamTest] message[${i}]:`, {
        // Direct property access
        content: m.content,
        type: m.type,
        id: m.id,
        // Constructor format access
        hasKwargs: "kwargs" in m,
        kwargsContent: m.kwargs?.content,
        // Object type
        constructor: m.constructor?.name,
        proto: Object.getPrototypeOf(m)?.constructor?.name,
        // All own keys
        ownKeys: Object.keys(m),
      });
    });
  }, [thread.messages]);

  return (
    <div style={{ padding: 20, fontFamily: "monospace", maxWidth: 800 }}>
      <h1>Brainstorm Stream Test</h1>
      <p>Loading: {String(thread.isLoading)}</p>
      <p>Error: {String(thread.error ?? "none")}</p>
      <p>Messages: {thread.messages?.length ?? 0}</p>

      <form
        onSubmit={async (e) => {
          e.preventDefault();
          const input = (e.target as HTMLFormElement).elements.namedItem(
            "input"
          ) as HTMLInputElement;
          await thread.submit({ messages: [{ role: "human", content: input.value }] });
          input.value = "";
        }}
      >
        <input
          name="input"
          placeholder="Say something..."
          style={{ width: 400, padding: 8, marginRight: 8 }}
        />
        <button type="submit" disabled={thread.isLoading}>
          Send
        </button>
      </form>

      <h2>Messages</h2>
      {thread.messages?.map((m: any, i: number) => (
        <div key={i} style={{ background: "#f5f5f5", padding: 12, marginBottom: 8, borderRadius: 4 }}>
          <strong>type: {m.type} | content defined: {String(m.content !== undefined)} | kwargs.content defined: {String(m.kwargs?.content !== undefined)}</strong>
          <pre style={{ overflow: "auto", maxHeight: 200 }}>
            {typeof m.content === "string"
              ? m.content
              : m.content
                ? JSON.stringify(m.content, null, 2)
                : `(content undefined — kwargs.content: ${JSON.stringify(m.kwargs?.content)?.slice(0, 200)})`}
          </pre>
        </div>
      ))}

      <h2>Raw Values</h2>
      <pre style={{ background: "#f5f5f5", padding: 12, overflow: "auto", maxHeight: 400 }}>
        {JSON.stringify(thread.values, null, 2)?.slice(0, 3000)}
      </pre>
    </div>
  );
}
